import { render, staticRenderFns } from "./PlayersTable.vue?vue&type=template&id=3f7021df&scoped=true&"
import script from "./PlayersTable.vue?vue&type=script&lang=js&"
export * from "./PlayersTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayersTable.vue?vue&type=style&index=0&id=3f7021df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7021df",
  null
  
)

export default component.exports